import { doLogin, doLogout, getUserData } from '../../logic/asApi';
import { devlog } from '../../logic/utils.ts';
import styleText from './login.css?raw';

export class AsLogin extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  private lastError = '';
  private userData: any;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsLogin.sheet
    ];
    this.render();
  }

  private render() {
    this.shadowRoot!.innerHTML = /*html*/`
      <div class="as-login">
        <form id="loginForm">
          email: <input name="eMail" id="email" autocomplete="email" type="email"><br>
          password: <input name="password" id="password" type="password" autocomplete="current-password"><br>
          <button type="button" id="loginButton">login</button>
        </form>
        
        <button type="button" id="logoutButton">logout</button><br>
        ${this.lastError ? `<span id="loginError">${this.lastError}</span>` : ''}
        
        user's first name: <span id="userFirstName">${this.userData?.firstName ?? ''}</span>
      </div>
    `;
  }

  connectedCallback() {
    this.addEventListeners();
    getUserData()
      .then(async response => {
        const data = await response.json();
        devlog(data);
        return data;
      })
      .then(data => {
        this.userData = data;
        devlog(this.userData);
        this.render();
        this.addEventListeners();
      })
      .catch(error => console.error(error));
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  private handleLogin = () => {
    const loginForm = this.shadowRoot?.querySelector('#loginForm') as HTMLFormElement | null;
    if (!loginForm) {
      console.error('loginForm is null');
      return;
    }

    doLogin(loginForm)
      .then(lres => {
        devlog(lres.data);
      })
      .catch(error => console.error(error));
  };

  private handleLogout = () => {
    doLogout()
      .then(response => response.json())
      .then(data => devlog(data))
      .catch(error => console.error(error));
  };

  private addEventListeners() {
    const loginButton = this.shadowRoot?.querySelector('#loginButton');
    const logoutButton = this.shadowRoot?.querySelector('#logoutButton');

    loginButton?.addEventListener('click', this.handleLogin);
    logoutButton?.addEventListener('click', this.handleLogout);
  }

  private removeEventListeners() {
    const loginButton = this.shadowRoot?.querySelector('#loginButton');
    const logoutButton = this.shadowRoot?.querySelector('#logoutButton');

    loginButton?.removeEventListener('click', this.handleLogin);
    logoutButton?.removeEventListener('click', this.handleLogout);
  }
}

customElements.define('as-login', AsLogin);
